import React                      from 'react'
import { Observer }               from 'mobx-react'

import { TEXT }                   from '../00_assets'
import { kde_api_user_t
       , ROLE_AUTH }              from '../02_api'
import { MApp }                   from '../09_model_app'


import { FIELD_TYPE
       , FormError
       , FormField
       , form_model
       , IFormEditor
       , IFormEditorModel
       , VALID }                  from './05_ui_form_input'
import { SelectRole }             from './08_ui_role_select'
import { SelectWorkgroup }        from './09_ui_workgroup_select'


export function create_user_editor_model ( user: kde_api_user_t )
{
  const fields =
    { username : { label: TEXT.UI_USERNAME
                 , init: user.username || ''
                 , type: FIELD_TYPE.INPUT
                 , is_valid: VALID.non_empty_txt
                 , required: true
                 , args: { autoComplete: "this_is_not_login_username" }
                 }
    , email    : { label: TEXT.UI_EMAIL
                 , init: user.email || ''
                 , type: FIELD_TYPE.INPUT
                 , is_valid: VALID.non_empty_txt
                 , args: { autoComplete: "this_is_not_login_email" }
                 , required: true }
    , password : { label: TEXT.UI_LOGIN_PASSWORD
                 , init: ''
                 , type: FIELD_TYPE.PASSWORD
                 , is_valid: VALID.non_empty_txt
                 , required: true
                 }
    , role     : { label: TEXT.UI_ROLE
                 , init: user.role.id
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: VALID.non_empty_num
                 , required: true
                 }
    , workgroup: { label: TEXT.UI_MENU_WORKGROUPS
                 , init: user.workgroup? user.workgroup.id : 0
                 , type: FIELD_TYPE.CUSTOM
                 , is_valid: VALID.non_empty_num
                 , required: true
                 }
  }

  return form_model( fields
                   , ( data: IFormEditorModel ) =>
                     ({ username : data.username.value( )
                      , email    : data.email.value( )
                      , password : data.password.value( ).length? data.password.value( ) : undefined
                      , role     : { id: data.role.value( ) }
                      , workgroup: { id: data.workgroup.value( ) }
                      })
                   ) ;
}


export const UserEditor: React.FC< { form: IFormEditor } > = ( { form } ) =>
<Observer render={ ( ) => 
{ 
  const user = MApp( ).user ;

  return <div>
      <FormField field={ form.model.email    } />
      <FormField field={ form.model.username } />
      <FormField field={ form.model.password } />
      <FormField field={ form.model.role }>
        <SelectRole
          userAuth={ user? ROLE_AUTH[ user.role.name ] : 0 } 
          className="w-100"
          { ...form.model.role.bind( ) }
          />
      </FormField>
      <FormField field={ form.model.workgroup }>
        <SelectWorkgroup 
          className="w-100"
          { ...form.model.workgroup.bind( ) }
        />
      </FormField>

      <FormError has={ form.show_error( ) } />
    </div> ;
} } /> ;
